module.exports = __webpack_public_path__ + "img/08_mpi_2.e5976416.jpg";